/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type queries_ConfigContanceGeneralSettingsQueryVariables = {||};
export type queries_ConfigContanceGeneralSettingsQueryResponse = {|
  +configConstance: ?{|
    +faqsUrl: ?string,
    +legalInfoUrl: ?string,
    +privacyUrl: ?string,
  |}
|};
export type queries_ConfigContanceGeneralSettingsQuery = {|
  variables: queries_ConfigContanceGeneralSettingsQueryVariables,
  response: queries_ConfigContanceGeneralSettingsQueryResponse,
|};
*/


/*
query queries_ConfigContanceGeneralSettingsQuery {
  configConstance {
    faqsUrl
    legalInfoUrl
    privacyUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConfigConstance",
    "kind": "LinkedField",
    "name": "configConstance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "faqsUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "legalInfoUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "privacyUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_ConfigContanceGeneralSettingsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "queries_ConfigContanceGeneralSettingsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_ConfigContanceGeneralSettingsQuery",
    "operationKind": "query",
    "text": "query queries_ConfigContanceGeneralSettingsQuery {\n  configConstance {\n    faqsUrl\n    legalInfoUrl\n    privacyUrl\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e70c4f45f3791bd016c8ce3cc978e157';

module.exports = node;
